import { apiWrapper } from "@ch/api";
import {
  type NewPayments,
  type Payments,
  PaymentsControllerService,
} from "@ch/generated";
import useLoading from "@ch/helpers/hooks/useLoading";
import { handleError } from "@ch/helpers/utils/handleError";
import { NotifyInfo } from "@ch/helpers/utils/helpers";
import { useState } from "react";

const useInitializePayment = () => {
  const { loading, startLoading, stopLoading } = useLoading();
  const [paymentData, setPaymentData] = useState<Payments | null>(null);

  const initializePayment = async (
    requestBody: NewPayments,
    callback?: (data?: Payments) => void,
  ) => {
    if (paymentData) {
      NotifyInfo(
        "This seems to be a duplicate transaction. You can retry a pending transaction by accessing your Payment History under your settings.",
      );
    } else {
      startLoading();
      try {
        const data = await apiWrapper(() =>
          PaymentsControllerService.paymentsControllerInitializePayment({
            requestBody,
          }),
        );
        setPaymentData(data);
        callback?.(data);
      } catch (error) {
        handleError(error);
      } finally {
        stopLoading();
      }
    }
  };
  return {
    paymentData,
    initializePayment,
    initializing: loading,
  };
};

export default useInitializePayment;
